module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"companies":"Companies","users":"Users","connections_per_week":"Connections / week"},"fr":{"companies":"Sociétés","users":"Utilisateurs","connections_per_week":"Connections / semaine"},"de":{"companies":"Firmen","users":"Benutzer","connections_per_week":"Verbindungen / Woche"}}')
  delete Component.options._Ctor
}
